import { Injectable} from '@angular/core';
//import { CookieService } from 'angular2-cookie/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class AuthService {

    private adminDefaultUser = 'admin';
    private in: string = '/api/login';
    private out: string = '/api/logout';
    private check: string = '/api/isLoggedIn/'+this.adminDefaultUser;
    public loggedInUser: string;
    public isLoggedIn: boolean;

    constructor(private http: Http) {
    }

    login(credentials: Object): Promise<any> {
        return this.http.post(this.in, credentials)
                .toPromise()
                .then(response => {
                    this.isLoggedIn = true;
                    this.loggedInUser = response.text();
                }) // returns the user (string)
                .catch(this.handleError);
    }

    logout(): Promise<any> {
        return this.http.get(this.out)
                .toPromise()
                .then(response => {
                    this.isLoggedIn = false;
                    this.loggedInUser = null;
                })
                .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('Auth API error', error);
        return Promise.reject(error.message || error);
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/auth.service.ts